import Vue from 'vue';
import '@/assets/tailwind.css';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

Sentry.init({
  Vue,
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
});

Vue.config.productionTip = false;

const host = window.location.host;
const parts = host.split('.');

export const versionHash = '{{POST_BUILD_HASH}}';

if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = function() {};
}

const appSwitch = async () => {
  if (
    parts[0] === `${process.env.VUE_APP_ADMIN_SUBDOMAIN}` ||
    process.env.NODE_ENV === 'review'
  ) {
    return await import('./apps/dashboardSwitch');
  } else if (parts[0] === 'invitations') {
    return await import('./apps/invitations/app');
  } else if (parts[0] === 'signup') {
    return await import('./apps/signup/app');
  }
};

appSwitch();
